<template>
  <div class="swipe module-item-wrap">
    <van-swipe :autoplay="3000" indicator-color="#FF3400">
      <van-swipe-item v-for="(item, index) in swiperList" :key="index">
        <img :src="item.imgUrl" class="img-style" @click="goLandingPage(item)" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { pathMatch } from '../../common'
export default {
  name: 'carousel',
  components: {},
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      swiperList: []
    }
  },
  created() {
  },
  mounted() {
    this.getData()
  },
  methods: {
    goLandingPage ({ path, params }) {
      if (!path && !params) {
        return
      }
      this.$router.push(pathMatch[path] + params)
    },
    getData () {
      this.swiperList = this.config.moduleData.list || []
      // this.$service.bannerInfo({
      //   showType: this.$constants.getStorage('showType') || 'normal',
      //   tagAdType: 'banner',
      //   channel: 'web'
      // }).then(res => {
      //   this.swiperList = res.data
      // })
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../main.styl'
.img-style {
  object-fit: contain;
}
.swipe, .swipe img {
  height: 164px;
  width: 375px;
}

</style>
